import Vue from "vue";
import Router from "vue-router";
import { routes } from "./config/router.config";
Vue.use(Router);

const VueRouterPush = Router.prototype.push;
const originReplace = Router.prototype.replace
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};

Router.prototype.replace = function push(location){
  return originReplace.call(this,location).catch(err=>err)
}


const router = new Router({
  mode: "history",
  routes,
  scrollBehavior(){
	return {
		x:0,
		y:0
	}
  }
});
export default router;
/* export default new Router({
  mode: 'history',
  routes,
}) */
